import { GenericObject, copyFields, fixDates } from '@synergy/models';

import { User } from './user';

export class TransitionActivity {
    public id!: number;
    public fromType!: string;
    public fromId!: number;
    public toType!: string;
    public toId!: number;
    public toNumber?: number;
    public fromNumber?: number;
    public toStatus?: string;
    public toTotalNetPrice?: number;
    public createdAt!: Date;
    public updatedAt!: Date;
    public createdBy!: User;
    public updatedBy!: User;

    public static fromPlainObject(object: GenericObject): TransitionActivity {
        const transition = new TransitionActivity();

        copyFields(object, transition);

        if (object['createdBy']) {
            transition.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            transition.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        if (object['meta']) {
            if (object['meta']['fromNumber']) {
                transition.fromNumber = object['meta']['fromNumber'];
            }

            if (object['meta']['toNumber']) {
                transition.toNumber = object['meta']['toNumber'];
            }

            transition.toStatus = object['meta']['toStatus'];
            transition.toTotalNetPrice = object['meta']['toTotalNetPrice'];
        }

        fixDates(transition, ['createdAt', 'updatedAt']);

        return transition;
    }
}
